import React from 'react';
import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-video.css';
interface BannerProps {
    gallaryVal: { imageUrl: string }[];
}
const images = [
  "https://png.pngtree.com/png-clipart/20250120/original/pngtree-smiling-young-student-with-books-in-hand-png-image_19835738.png",
  "https://png.pngtree.com/png-clipart/20250120/original/pngtree-smiling-young-student-with-books-in-hand-png-image_19835738.png",
  "https://png.pngtree.com/png-clipart/20250120/original/pngtree-smiling-young-student-with-books-in-hand-png-image_19835738.png",
  "https://png.pngtree.com/png-clipart/20250120/original/pngtree-smiling-young-student-with-books-in-hand-png-image_19835738.png",
  "https://png.pngtree.com/png-clipart/20250120/original/pngtree-smiling-young-student-with-books-in-hand-png-image_19835738.png",
  "https://png.pngtree.com/png-clipart/20250120/original/pngtree-smiling-young-student-with-books-in-hand-png-image_19835738.png",
];

const LightboxGallery: React.FC<BannerProps> = ({ gallaryVal = [] }) => {
  const onInit = () => {
    console.log('lightGallery initialized');
  };

  return (
    <div className="p-4">
      <LightGallery
        onInit={onInit}
        speed={500}
        plugins={[lgZoom, lgVideo]}
        elementClassNames="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4"
      >
        {gallaryVal.map((img, idx) => (
          <a
            key={idx}
            href={img?.imageUrl}
            // data-lg-size="1400-800"
            className="gallery-item"
          >
            <img
              className="w-full p-4 object-cover border rounded-md shadow-md"
              src={img?.imageUrl}
              alt={`Gallery ${idx}`}
            />
          </a>
        ))}
      </LightGallery>
    </div>
  );
};

export default LightboxGallery;
